export const USStateOptions = [
  { label: 'Armed Forces Americas', value: 'AA', activeProviderState: false },
  { label: 'Armed Forces Europe', value: 'AE', activeProviderState: false },
  { label: 'Alaska', value: 'AK', activeProviderState: true },
  { label: 'Alabama', value: 'AL', activeProviderState: true },
  { label: 'Armed Forces Pacific', value: 'AP', activeProviderState: false },
  { label: 'Arkansas', value: 'AR', activeProviderState: true },
  { label: 'American Samoa', value: 'AS', activeProviderState: false },
  { label: 'Arizona', value: 'AZ', activeProviderState: true },
  { label: 'California', value: 'CA', activeProviderState: true },
  { label: 'Colorado', value: 'CO', activeProviderState: true },
  { label: 'Connecticut', value: 'CT', activeProviderState: true },
  { label: 'District of Columbia', value: 'DC', activeProviderState: true },
  { label: 'Delaware', value: 'DE', activeProviderState: true },
  { label: 'Florida', value: 'FL', activeProviderState: true },
  { label: 'Georgia', value: 'GA', activeProviderState: true },
  { label: 'Guam', value: 'GU', activeProviderState: false },
  { label: 'Hawaii', value: 'HI', activeProviderState: true },
  { label: 'Iowa', value: 'IA', activeProviderState: true },
  { label: 'Idaho', value: 'ID', activeProviderState: true },
  { label: 'Illinois', value: 'IL', activeProviderState: true },
  { label: 'Indiana', value: 'IN', activeProviderState: true },
  { label: 'Kansas', value: 'KS', activeProviderState: true },
  { label: 'Kentucky', value: 'KY', activeProviderState: true },
  { label: 'Louisiana', value: 'LA', activeProviderState: true },
  { label: 'Massachusetts', value: 'MA', activeProviderState: true },
  { label: 'Maryland', value: 'MD', activeProviderState: true },
  { label: 'Maine', value: 'ME', activeProviderState: true },
  { label: 'Michigan', value: 'MI', activeProviderState: true },
  { label: 'Minnesota', value: 'MN', activeProviderState: true },
  { label: 'Missouri', value: 'MO', activeProviderState: true },
  { label: 'Northern Mariana Islands', value: 'MP', activeProviderState: false },
  { label: 'Mississippi', value: 'MS', activeProviderState: true },
  { label: 'Montana', value: 'MT', activeProviderState: true },
  { label: 'North Carolina', value: 'NC', activeProviderState: true },
  { label: 'North Dakota', value: 'ND', activeProviderState: true },
  { label: 'Nebraska', value: 'NE', activeProviderState: true },
  { label: 'New Hampshire', value: 'NH', activeProviderState: true },
  { label: 'New Jersey', value: 'NJ', activeProviderState: true },
  { label: 'New Mexico', value: 'NM', activeProviderState: true },
  { label: 'Nevada', value: 'NV', activeProviderState: true },
  { label: 'New York', value: 'NY', activeProviderState: true },
  { label: 'Ohio', value: 'OH', activeProviderState: true },
  { label: 'Oklahoma', value: 'OK', activeProviderState: true },
  { label: 'Oregon', value: 'OR', activeProviderState: true },
  { label: 'Pennsylvania', value: 'PA', activeProviderState: true },
  { label: 'Puerto Rico', value: 'PR', activeProviderState: false },
  { label: 'Rhode Island', value: 'RI', activeProviderState: true },
  { label: 'South Carolina', value: 'SC', activeProviderState: true },
  { label: 'South Dakota', value: 'SD', activeProviderState: true },
  { label: 'Tennessee', value: 'TN', activeProviderState: true },
  { label: 'Trusted Territories', value: 'TT', activeProviderState: false },
  { label: 'Texas', value: 'TX', activeProviderState: true },
  { label: 'United States Minor Outlying Islands', value: 'UM', activeProviderState: false },
  { label: 'Utah', value: 'UT', activeProviderState: true },
  { label: 'Virginia', value: 'VA', activeProviderState: true },
  { label: 'Virgin Islands, U.S.', value: 'VI', activeProviderState: false },
  { label: 'Vermont', value: 'VT', activeProviderState: true },
  { label: 'Washington', value: 'WA', activeProviderState: true },
  { label: 'Wisconsin', value: 'WI', activeProviderState: true },
  { label: 'West Virginia', value: 'WV', activeProviderState: true },
  { label: 'Wyoming', value: 'WY', activeProviderState: true }
];

export const IsValidStateAbbrev = (abbrev: string): boolean => USStateOptions.map((options) => options.value).includes(abbrev.toLocaleUpperCase());

/**
 * Use this to get state longName from abbreviations more efficiently than with Array.find().
 *
 * ex. stateAbbrevMap['OH'] gets you 'Ohio'
 */

export const USStateAbbrevMap: { [abbrev: string]: string; } =
  USStateOptions.reduce((memo: { [abbrev: string]: string; }, option) => {
    // eslint-disable-next-line no-param-reassign
    memo[option.value] = option.label;
    return memo;
  }, {});

export const USStateNameMap: Array<{ name: string; value: string; }> =
  USStateOptions.reduce((memo: Array<{ name: string; value: string; }>, option) => {
    memo.push({ name: option.label, value: option.value });
    return memo;
  }, []);

export const activeProviderUSStateNameMap: Array<{ name: string; value: string; }> =
  USStateOptions
    .filter((option) => option.activeProviderState)
    .map((option) => ({
      name: option.label,
      value: option.value,
    }));
